import React from "react";

import { motion } from "framer-motion";
import "./WhatWeDo.css";
import { FaBullhorn, FaPalette, FaChartPie, FaLaptopCode, FaVideo, FaEnvelopeOpenText } from "react-icons/fa";



function WhatWeDo() {
  return (
    <section className="what-we-do">
      <h2>What we do?</h2>
      <p>
      We help brands grow by turning culture and creativity into digital strategies that build trust and connection Like the Following
      </p>
      <div className="services-grid">
        {[ 
  { icon: <FaBullhorn />, title: "Advertising", text: "We create strategic advertising campaigns to maximize your brand's visibility and market reach." },
  { icon: <FaPalette />, title: "Brand Identity", text: "We craft unique brand identities, including logos, color schemes, and visual storytelling, to make your business stand out." },
  { icon: <FaChartPie />, title: "Data-Driven Marketing", text: "We leverage analytics and consumer insights to optimize campaigns and increase conversion rates." },
  { icon: <FaLaptopCode />, title: "Web & App Development", text: "We design and develop high-performing websites and applications that drive engagement and sales." },
  { icon: <FaVideo />, title: "Multimedia Content", text: "We produce high-quality video content, animations, and graphics to captivate your audience." },
  { icon: <FaEnvelopeOpenText />, title: "Email & Automation", text: "We design automated email marketing campaigns that nurture leads and drive customer retention." }
        ].map((service, index) => (
          <motion.div 
            className="service-item"
            key={index}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.2 }}
            viewport={{ once: true }}
          >
            <span className="icon">{service.icon}</span>
            <h3>{service.title}</h3>
            <p>{service.text}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}

export default WhatWeDo;
